/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const submitAdditionalAnswersDataSchema = z.object({
	answers: z.array(
		z.object({
			questionId: z.string().uuid(),
			answer: z.string().nullable(),
			optionId: z.string().uuid().nullable(),
		}),
	),
})

export type SubmitAdditionalAnswersDataSchema = z.infer<typeof submitAdditionalAnswersDataSchema>
